module.exports = __webpack_public_path__ + "img/American_Credit_Business_Loans_Referral_Program.589c07f.png";